import Styled from 'styled-components';

import { VALID_COLOR } from '../../lib/StyledComponents';

const DEFAULT_STYLE: VALID_COLOR = 'default';

export interface IBannerProps {
  bannerStyle?: VALID_COLOR;
  padding?: string;
}

export const Banner = Styled.div<IBannerProps>`
  background-color: ${({ theme: { banner }, bannerStyle }) => banner[bannerStyle || DEFAULT_STYLE].colorBackground};
  color: ${({ theme: { banner }, bannerStyle }) => banner[bannerStyle || DEFAULT_STYLE].colorText};
  border-top: none;
  border-bottom: 1px solid ${({ theme: { banner }, bannerStyle }) => banner[bannerStyle || DEFAULT_STYLE].colorBorder};
  border-left: ${({ theme: { banner }, bannerStyle }) => {
    const colorBorderLeft = banner[bannerStyle || DEFAULT_STYLE].colorBorderLeft;
    if (colorBorderLeft) { return `4px solid ${colorBorderLeft}`; }
  }};
  font-size: ${({ theme: { banner }}) => banner.fontSizeBannerText};
  font-weight: ${({ theme: { banner }}) => banner.fontWeightBanner};
  padding:
    ${({ padding, theme: { banner } } ) => (
      padding
        ? padding
        : banner.paddingBanner
    )};
`;

Banner.displayName = 'Banner';
